import { render, staticRenderFns } from "./Vouchers.vue?vue&type=template&id=98f4dfaa&scoped=true&"
import script from "./Vouchers.vue?vue&type=script&lang=js&"
export * from "./Vouchers.vue?vue&type=script&lang=js&"
import style0 from "./Vouchers.vue?vue&type=style&index=0&id=98f4dfaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98f4dfaa",
  null
  
)

export default component.exports